import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { MenuGroupDeleteService } from '../../services';

export const fetchMenuGroupDelete = createAsyncThunk(
    'menuGroupDelete/fetchMenuGroupDelete',
    async ({ id }) => {
        const response = await MenuGroupDeleteService(id)
        return response.result
    }
)

const menuGroupDeleteSlice = createSlice({
    name: 'menuGroupDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMenuGroupDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMenuGroupDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchMenuGroupDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default menuGroupDeleteSlice.reducer;
